import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { Design } from '@/model/document2/page/surface/design/design';
import { PlainTextLayer } from '@/model/document2/page/surface/design/layer/plainTextLayer';
import { ProfileData } from "@/utilityModels/profileData";
import { Const } from '@/const';
import { SimpleTextLayer } from '@/model/document2/page/surface/design/layer/simpleTextLayer';

// プロフィール挿入コマンド
export class InsertProfileCommand implements ICommandBase
{
    private data! : ProfileData;
    private design! : Design;

    private doneCallback! : () => void;

    private oldDataArray : Array<{ id : string, text : string, object : any }> = new Array();

    constructor(data : ProfileData, design : Design, doneCallback : () => void)
    {
        this.data = data;
        this.design = design;
        this.doneCallback = doneCallback;
    }

    public do() : void
    {
        var allLayers = this.design.getAllLayers(false);
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];
            if((layer instanceof PlainTextLayer || layer instanceof SimpleTextLayer) && !layer.isLocked)
            {
                var newText = this.getProfileText(layer);

                if(newText.length > 0)
                {
                    // 文字のバックアップ
                    this.oldDataArray.push({
                        id : layer.id,
                        text : layer.text,
                        object : layer instanceof PlainTextLayer ? layer.getBackupTextObject() : null
                    });

                    // 文字の差し替えをする
                    layer.text = newText;
                    if(layer instanceof PlainTextLayer)
                    {
                        // 文法情報を差し替え
                        layer.setWholeTextInfo(layer.baseTextInfo);
                    }
                }
            }
        }

        this.doneCallback();
    }

    private getProfileText(layer : PlainTextLayer | SimpleTextLayer)
    {
        var newText = "";
        if(layer.profileKey == Const.PROFILE_KEY_NAME) { newText = this.data.name; }
        else if(layer.profileKey == Const.PROFILE_KEY_FURIGANA) { newText = this.data.furigana; }
        else if(layer.profileKey == Const.PROFILE_KEY_NAME_ROMAN) { newText = this.data.nameRoman; }
        else if(layer.profileKey == Const.PROFILE_KEY_CELL_TEL) { newText = this.data.cellTel; }
        else if(layer.profileKey == Const.PROFILE_KEY_MAIL) { newText = this.data.mail; }
        else if(layer.profileKey == Const.PROFILE_KEY_COMPANY) { newText = this.data.company; }
        else if(layer.profileKey == Const.PROFILE_KEY_DIV) { newText = this.data.div; }
        else if(layer.profileKey == Const.PROFILE_KEY_TEL) { newText = this.data.tel; }
        else if(layer.profileKey == Const.PROFILE_KEY_FAX) { newText = this.data.fax; }
        else if(layer.profileKey == Const.PROFILE_KEY_ZIP) { newText = this.data.zip; }
        else if(layer.profileKey == Const.PROFILE_KEY_ADDRESS1) { newText = this.data.address1; }
        else if(layer.profileKey == Const.PROFILE_KEY_ADDRESS2) { newText = this.data.address2; }
        else if(layer.profileKey == Const.PROFILE_KEY_URL) { newText = this.data.url; }

        return newText;
    }

    public undo() : void
    {
        var allLayers = this.design.getAllLayers(false);
        for(var i = 0; i < this.oldDataArray.length; ++i)
        {
            var oldData = this.oldDataArray[i];
            for(var j = 0; j < allLayers.length; ++j)
            {
                var layer = allLayers[j];
                if((layer instanceof PlainTextLayer || layer instanceof SimpleTextLayer) && layer.id == oldData.id)
                {
                    // テキストと文法情報の復帰
                    layer.text = oldData.text;
                    layer.setBackupTextObject(oldData.object);
                }
            }
        }

        this.doneCallback();
    }

    public redo() : void
    {
        var allLayers = this.design.getAllLayers(false);
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];
            if((layer instanceof PlainTextLayer || layer instanceof SimpleTextLayer)  && !layer.isLocked)
            {
                var newText = this.getProfileText(layer);

                if(newText.length > 0)
                {
                    // 文字の差し替えをする
                    layer.text = newText;
                    if(layer instanceof PlainTextLayer)
                    {
                        // 文法情報を差し替え
                        layer.setWholeTextInfo(layer.baseTextInfo);
                    }
                }
            }
        }

        this.doneCallback();
    }
}